import Button from "@mui/material/Button";

/**
 * ContactSalesButton component.
 *
 * Renders a button to contact sales. It uses MaterialUI's Button component to render the button.
 *
 * @returns The rendered ContactSalesButton component.
 */
export default function ContactSalesButton() {
  return (
    <Button
      onClick={() => window.open("https://www.scaleip.com/contact-us", "_blank", "noopener,noreferrer")}
      sx={{ height: "50px", width: "100%" }}
      variant="contained"
    >
      Contact Sales
    </Button>
  );
}
